import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Gerencia o scroll a cada navegação:
 * - Sem hash → rola pro topo.
 * - Com hash (ex.: "/#vagas" vindo de outra página) → rola até a seção. Como
 *   parte do conteúdo carrega de forma assíncrona (lista de vagas), tenta
 *   algumas vezes até o elemento existir antes de desistir.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (tries++ < 25) timer = setTimeout(tryScroll, 60);
    };
    tryScroll();

    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
